import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyListUserShipmentPricesForReportsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportUserCOCReport = ({ userId }) => {
  const [fetchCOCUserReport, { isLoading, isFetching }] =
    useLazyListUserShipmentPricesForReportsQuery();

  const handleDownload = async (data) => {
    try {
      const responseData = await fetchCOCUserReport({}).unwrap();

      console.log("Response Data:", responseData);

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        Name: row.responsibleUserName || "N/A",
        Pending: row?.totalNotPaid || 0,
        Paid: row?.totalPaid || 0,
        Collected: row?.totalCollected || 0,
        Total: row?.total || 0,
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "COC_User_Report",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error("Error fetching COC user report data: " + error.message);
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportUserCOCReport;
